interface DecodedToken {
  exp: number
  iat: number
  sub: string
}

export const getJWTTokenExpirationDate = (token: string) => {
  const decodedToken = JSON.parse(atob(token.split('.')[1])) as DecodedToken
  const expirationDate = new Date(decodedToken.exp * 1000) // Convert to milliseconds
  return expirationDate
}

// verifies JWT token exiration and runs call back if expired
export const verifyTokenExpired = (token: string) => {
  const expirationDate = getJWTTokenExpirationDate(token)
  const currentTime = new Date()
  const isTokenExpired = expirationDate && expirationDate < currentTime

  return isTokenExpired
}

export const ALLOWED_NON_AUTHENTICATED_PATHS = [
  'auth',
  'signup',
  'auth/password/forgot',
  'auth/google',
]
